import { dateAndTimeToDateTimeTyped } from '@utils';

import {
  activityTypeIds,
  activityValueTypes,
  mapPersonValuesToDto,
  normalizeAdvancedValues,
  saveActivity$,
} from '../../common';

const saveServiceActivity$ = data => {
  const {
    startDate,
    endDate,
    organizationGuid,
    loggedInUserId,
    persons,
    isAdvancedMode,
    hoursServed,
    youthHours,
    adultHours,
    isPersonalActivity = false,
    isApproved,
    startTime,
    endTime,
    isDeclined,
  } = data;
  const basicValues = {
    [activityValueTypes.HOURS]: hoursServed,
  };
  const personValues = mapPersonValuesToDto({
    persons,
    organizationGuid,
    loggedInUserId,
    isAdvancedMode,
    isApproved,
    isDeclined,
    basicAdultValues: basicValues,
    basicYouthValues: basicValues,
    advancedValues: {
      [activityValueTypes.HOURS]: {
        ...normalizeAdvancedValues(youthHours),
        ...normalizeAdvancedValues(adultHours),
      },
    },
  });
  const startDateTime = dateAndTimeToDateTimeTyped(startDate, startTime, {
    date: undefined,
    time: 'h:mma',
  });
  const endDateTime = dateAndTimeToDateTimeTyped(endDate, endTime, {
    date: undefined,
    time: 'h:mma',
  });

  const processedData = {
    ...data,
    ...personValues,
    activityTypeId: activityTypeIds.SERVICE_PROJECTS,
    startDateTime,
    endDateTime,
    hostOrganizationGuid: organizationGuid,
    isPersonalActivity,
    isEveryChildOrg: false,
  };

  return saveActivity$(processedData);
};

export default {
  saveServiceActivity$,
};
